import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { TiTick } from "react-icons/ti";
import axios from "axios";
import SEO from "../../components/common/SEO";

const OurStoryAndServices = () => {
  const [homeData, setHomeData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  useEffect(() => {
    const fetchHomeData = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/home/get-sections`);
        const data = res.data?.data?.[0]; 
        setHomeData(data);
      } catch (err) {
        console.error("Error fetching home data:", err);
        setError("Failed to load content. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchHomeData();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center py-20">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#2F9BD6]"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-20">
        <p className="text-xl text-red-500">{error}</p>
      </div>
    );
  }

  if (!homeData) {
    return (
      <div className="text-center py-20 text-gray-500">
        No data available for this section.
      </div>
    );
  }

  return (
    <>
      {/* SEO Meta Tags using database fields */}
      <SEO 
        title={homeData.metaTitle || homeData.heading || "Home"}
        description={homeData.metaDescription || homeData.subheading || "BBSR Services - Professional Business Solutions"}
        keywords={homeData.metaKeywords || "BBSR Services, business solutions"}
        canonical={homeData.canonicalUrl || "https://www.bbsrservices.co.in/"}
        image={homeData.images?.[0] || "https://www.bbsrservices.co.in/logo.png"}
        type="website"
      />

      <div className="gap-4 px-4 md:px-10 pt-10 flex flex-col">
        {/* Our Story Section */}
        <section>
          <div className="w-full pb-6 md:pb-10">
            <div className="flex flex-col justify-center space-y-4">
              <div className="flex justify-center md:justify-start" data-aos="fade-up">
                <span className="border-b-2 border-[#FF3131] text-[#FF3131] font-semibold tracking-wide pb-1">
                  {homeData.heading || "Our Story"}
                </span>
              </div>

              <h2
                data-aos="fade-up"
                className="text-2xl sm:text-3xl lg:text-[44px] font-semibold text-[#191919] leading-relaxed"
              >
                {homeData.subheading || "We Provide Business Solutions Tailored to Your Needs"}
              </h2>

              {homeData.description?.map((desc, index) => (
                <div
                  key={index}
                  data-aos="fade-down-right"
                  className="text-[#686D70] text-base sm:text-lg leading-relaxed text-justify"
                  dangerouslySetInnerHTML={{ __html: desc }}
                />
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 items-start gap-2">
            <div data-aos="fade-down" className="flex justify-center md:justify-start">
              <img
                src={homeData.images?.[0] || "https://via.placeholder.com/500x400?text=Our+Story"}
                alt={homeData.heading || "Our Story"}
                className="w-full h-auto rounded-2xl object-cover shadow-md"
              />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 p-4">
              {homeData.keyPoints?.map((point, idx) => (
                <div
                  key={idx}
                  data-aos={idx % 2 === 0 ? "fade-up" : "fade-down"}
                  className="flex items-start gap-2"
                >
                  <span className="rounded-full p-1 border border-[#1E85FC] flex-shrink-0">
                    <TiTick size={15} className="text-[#1E85FC]" />
                  </span>
                  <div className="text-gray-700 text-sm text-justify sm:text-base">
                    <span className="font-semibold block">{point.title}</span>
                    <span dangerouslySetInnerHTML={{ __html: point.description }} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default OurStoryAndServices;

// import React, { useEffect, useState } from "react";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import { TiTick } from "react-icons/ti";
// import axios from "axios";

// const OurStoryAndServices = () => {
//   const [homeData, setHomeData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     AOS.init({ duration: 1000 });
//   }, []);

//   useEffect(() => {
//     const fetchHomeData = async () => {
//       try {
//         const res = await axios.get(`${process.env.REACT_APP_API_URL}/home/get-sections`);
//         const data = res.data?.data?.[0]; 
//         setHomeData(data);
//       } catch (err) {
//         console.error("Error fetching home data:", err);
//         setError("Failed to load content. Please try again later.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchHomeData();
//   }, []);

//   if (loading) {
//     return (
//       <div className="flex justify-center items-center py-20">
//         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#2F9BD6]"></div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="text-center py-20">
//         <p className="text-xl text-red-500">{error}</p>
//       </div>
//     );
//   }

//   if (!homeData) {
//     return (
//       <div className="text-center py-20 text-gray-500">
//         No data available for this section.
//       </div>
//     );
//   }

//   return (
//     <div className="gap-4 px-4 md:px-10 pt-10 flex flex-col">
//       {/* Our Story Section */}
//       <section>
//         <div className="w-full pb-6 md:pb-10">
//           <div className="flex flex-col justify-center space-y-4">
//             {/* Section Label */}
//             <div className="flex justify-center md:justify-start" data-aos="fade-up">
//               <span className="border-b-2 border-[#FF3131] text-[#FF3131] font-semibold tracking-wide pb-1">
//                 {homeData.heading || "Our Story"}
//               </span>
//             </div>

//             {/* Subheading */}
//             <h2
//               data-aos="fade-up"
//               className="text-2xl sm:text-3xl lg:text-[44px] font-semibold text-[#191919] leading-relaxed"
//             >
//               {homeData.subheading || "We Provide Business Solutions Tailored to Your Needs"}
//             </h2>

//             {/* Description (supports HTML from Rich Text Editor) */}
//             {homeData.description?.map((desc, index) => (
//               <div
//                 key={index}
//                 data-aos="fade-down-right"
//                 className="text-[#686D70] text-base sm:text-lg leading-relaxed text-justify"
//                 dangerouslySetInnerHTML={{ __html: desc }}
//               />
//             ))}
//           </div>
//         </div>

//         <div className="grid grid-cols-1 md:grid-cols-2 items-start gap-2">
//           {/* Image */}
//           <div data-aos="fade-down" className="flex justify-center md:justify-start">
//             <img
//               src={homeData.images?.[0] || "https://via.placeholder.com/500x400?text=Our+Story"}
//               alt="Our Story"
//               className="w-full h-auto rounded-2xl object-cover shadow-md"
//             />
//           </div>

//           {/* Key Points */}
//           <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 p-4">
//             {homeData.keyPoints?.map((point, idx) => (
//               <div
//                 key={idx}
//                 data-aos={idx % 2 === 0 ? "fade-up" : "fade-down"}
//                 className="flex items-start gap-2"
//               >
//                 <span className="rounded-full p-1 border border-[#1E85FC] flex-shrink-0">
//                   <TiTick size={15} className="text-[#1E85FC]" />
//                 </span>
//                 <div className="text-gray-700 text-sm text-justify sm:text-base">
//                   <span className="font-semibold block">{point.title}</span>
//                   <span dangerouslySetInnerHTML={{ __html: point.description }} />
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default OurStoryAndServices;
